module.exports = __webpack_public_path__ + "img/about/80243-044.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-044.png
// module id = 42
// module chunks = 0